import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

export default function SuperAdminRoute() {
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');

  // اگر لاگین نکرده باشد، هدایت به صفحه لاگین ادمین
  if (!token) {
    return <Navigate to="/admin/login" replace />;
  }

  // اگر لاگین کرده اما سوپر ادمین نیست، دسترسی مسدود است
  if (!user.is_super_admin) {
    return (
      <div style={{ textAlign: 'center', marginTop: '50px', direction: 'rtl' }}>
        <h2>خطای دسترسی (403)</h2>
        <p>شما دسترسی لازم برای مشاهده این بخش را ندارید.</p>
      </div>
    );
  }

  return <Outlet />;
}
